import { Typography } from '@mui/material';
import React from 'react';

const Pay = () => {
    return (
        <div>
            <Typography>
                Payment System Comming Soon....
            </Typography>
        </div>
    );
};

export default Pay;